import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyConstructorFactory } from '@webapp/core/entities/external/Currency/Currency.factory'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  CreditCardItem,
  type CreditCardItemConstructor,
} from './CreditCardItem'
import { ItemCostAllocationConstructorFactory } from '../ItemCostAllocation'

export const CreditCardItemConstructorFactory =
  Factory.Sync.makeFactory<CreditCardItemConstructor>({
    id: Factory.each(() => faker.random.number()),
    creditcardId: Factory.each(() => faker.random.number()),
    description: Factory.each(() => faker.commerce.productName()),
    totalCost: Factory.each(() => faker.random.number()),
    currency: Factory.each(() => CurrencyConstructorFactory.build()),
    receivedOn: '2024-01-15',
    costAllocations: Factory.each(() => [
      ItemCostAllocationConstructorFactory.build(),
    ]),
    packingSlips: [],
    po: null,
    expense: null,
    matchedStatementItemIds: [],
    isMovable: true,
    unitCostDiffLog: null,
  })

export const CreditCardItemFactory = EntityFactory(
  CreditCardItem,
  CreditCardItemConstructorFactory
)
